import React from "react";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(() => ({
	badge: {
		display: "inline-block",
		padding: "2px 8px",
		fontSize: "11px",
		fontWeight: 700,
		letterSpacing: "0.05em",
		color: "#6b7280",
		backgroundColor: "#e5e7eb",
		borderRadius: "10px",
		textTransform: "uppercase",
	},
}));

const PausedBadge = () => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return <span className={classes.badge}>{t("label.paused")}</span>;
};

export default PausedBadge;
